import axios from 'axios';

export const PartnersService = {
  async getPartners({ page, perPage }) {
    const res = await axios.get('businessPartner/', {
      params: {
        page,
        size: perPage,
      },
    });

    if (res.status === 200) {
      return res.data;
    }
    return Promise.reject();
  },
  async getAllPartners() {
    const res = await axios.get('businessPartner/all/');

    if (res.status === 200) {
      return res.data;
    }

    return Promise.reject();
  },
  async createPartner(payload) {
    const res = await axios.post('businessPartner/', payload);

    if (res.status === 201) {
      return true;
    }
    return Promise.reject();
  },
  async updatePartner(payload, id) {
    const res = await axios.put(`businessPartner/${id}/`, payload);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
  async deletePartner(id) {
    const res = await axios.delete(`businessPartner/${id}/`);

    if (res.status === 200) {
      return true;
    }
    return Promise.reject();
  },
};
